import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApplicationHttpClient } from 'app/application-http-client';
import { LoanType } from 'app/modules/desking/models/enums';
import { Observable } from 'rxjs';

import { Form } from '../models/form';
import { FormPacket } from '../models/form-packet';

@Injectable()
export class FormService {
  // private instance variable to hold base url
  private apiUrl = '/forms/forms';

  public add(form: Form, file: any): Observable<Form> {
    const formData: FormData = new FormData();
    formData.set('name', form.name);
    formData.set('formFile', file);

    const headers = new HttpHeaders();
    // headers.set('Content-Type', 'multipart/form-data; boundary="arbitraryBoundary"');
    return this.http.post(this.apiUrl, formData, { headers: headers });
  }

  public download(formExternalId: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/download/${formExternalId}`, { responseType: 'blob' });
  }

  public get(formId: number): Observable<Form> {
    return this.http.get(`${this.apiUrl}/${formId}`);
  }

  public getAll(): Observable<Form[]> {
    return this.http.get(this.apiUrl);
  }

  public getPackets(configurationId: number, formId: number): Observable<FormPacket[]> {
    return this.http.get(`${this.apiUrl}/getPackets/${configurationId}/${formId}`);
  }

  public getStampedFormFiles(loanType: LoanType, paymentId: number, eventId: number, formId: number[]): Observable<any> {
    const options = {
      responseType: 'blob' as 'blob',
      rethrowErrors: true
    };
    return this.http.get(`${this.apiUrl}/${loanType}/${paymentId}/${eventId}/${formId}`, options);
  }

  public GetGuestSheetAsync(customerId: number, eventId: number): Observable<any> {
    const options = {
      responseType: 'blob' as 'blob',
      rethrowErrors: true
    };
    return this.http.get(`${this.apiUrl}/GuestSheet/${customerId}/${eventId}`, options);
  }

  public replace(formId: number, file: any): Observable<any> {
    const formData: FormData = new FormData();
    formData.set('formFile', file);
    return this.http.put(`${this.apiUrl}/replace/${formId}`, formData);
  }

  public update(form: Form): Observable<Form> {
    const body = { name: form.name };
    return this.http.put(`${this.apiUrl}/${form.id}`, body);
  }

  public delete(formId: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${formId}`);
  }

  constructor(private http: ApplicationHttpClient) {}
}
